// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__d7KhP","navBar":"styles_navBar__V93po","withShadow":"styles_withShadow___D1ik"};